import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { Observable } from 'rxjs/Observable';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { NgClass } from '@angular/common';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import * as moment from 'moment';

import { TestingTrailService, CommonService, OctTypeService } from '../../../services/index';
import { TestingTrailModel } from '../../../model/index';

@Component({
    selector: 'add-testing-window',
    templateUrl: './addTesting.component.html'
})
export class AddTestingComponent implements OnInit {
    title: string;
    public pageType: string;
    public list: any[] = [];
    testCtrl: FormControl;
    ostDoneCtrl: FormControl;
    assessmentDoneCtrl: FormControl;
    therapyDoneCtrl: FormControl;
    nextFollowupDateCtrl: FormControl;
    bilateralWillingCtrl: FormControl;
    billGenCtrl: FormControl;
    complaintCtrl: FormControl;
    testList: any[];
    ostDoneList: any[];
    assessmentDoneList: any[];
    therapyDoneList: any[];
    bilateralWillingList: any[];
    billList: any[];
    haList: any[] = [];
    complaintList: any[] = [];
    routeCtrl: FormControl;
    routeOptList: any[];
    testingtypeCtrl: FormControl;
    emplistCtrl: FormControl;
    emplist2Ctrl: FormControl;
    //public referencedata: any[] = [];
    //@Input() testingdata: TestingTrailModel[] = [];
    _testingdata: any[] = [];
    @Input() set testingdata(data: any[]) {
        // First, convert the date from string to Date object
        let convertedDate = null;
        if (data && data['nxt_fol_date'] && data['nxt_fol_date'] !== '0000-00-00' && data['nxt_fol_date'] !== '') {
            const dateStr = data['nxt_fol_date'];
            if (typeof dateStr === 'string') {
                // Parse YYYY-MM-DD format manually to avoid timezone issues
                const parts = dateStr.split('-');
                if (parts.length === 3) {
                    const year = parseInt(parts[0]);
                    const month = parseInt(parts[1]) - 1; // Month is 0-indexed
                    const day = parseInt(parts[2]);
                    if (!isNaN(year) && !isNaN(month) && !isNaN(day)) {
                        convertedDate = new Date(year, month, day);
                    }
                }
            } else if (dateStr instanceof Date) {
                convertedDate = dateStr;
            }
        }

        // CRITICAL: Set the converted date on the data object BEFORE assigning to _testingdata
        // This ensures the ngModel binding always has a Date object, never a string
        if (data) {
            data['nxt_fol_conv_date'] = convertedDate;
        }

        // Now assign the modified data object
        this._testingdata = data;
        this.octFromWalkin = !!(data && (data['oct_type_id'] || data['oct_yn'] === 'Yes'));

        // Apply disable logic for Edit case when testing is already 'No'
        if (data && data['testing'] === 'No') {
            setTimeout(() => { this.onTestingChange('No'); }, 200);
        }

        // Update the FormControl value (without triggering change detection)
        if (this.nextFollowupDateCtrl) {
            this.nextFollowupDateCtrl.setValue(convertedDate, { emitEvent: false });
        }

        if (data) {
            this.loadClientDetails(data['client_id']);
            // Initialize form controls when data is set - with longer delay to ensure all lists are loaded
            setTimeout(() => {
                this.initializeFormControls();
                // Force another initialization after a longer delay
                setTimeout(() => {
                    this.initializeFormControlsAfterLoad();
                }, 1000);
            }, 100);
        }

        if (this.testCtrl && data) {
            if (data['status'] && (data['status'].includes('Assessment') || data['status'].includes('Therapy'))) {
                this.testCtrl.disable();
            } else {
                this.testCtrl.enable();
            }
        }

        if (this.therapyDoneCtrl && data) {
            if (data['session_count'] && parseInt(data['session_count']) > 0) {
                let count = parseInt(data['session_count']);
                let completedSessions = parseInt(data['completed_sessions']) || 0;
                this.therapyDoneList = [];
                // Build therapy options starting from next session to complete
                for (let i = completedSessions + 1; i <= count; i++) {
                    this.therapyDoneList.push(i + ' session Completed');
                }
                // Clear previous therapy_done value for fresh entry
                this._testingdata['therapy_done'] = null;
                this.therapyDoneCtrl.setValue(null);
                // Clear next followup date for fresh entry
                this._testingdata['nxt_fol_conv_date'] = null;
                if (this.nextFollowupDateCtrl) {
                    this.nextFollowupDateCtrl.setValue(null);
                }

                // Clear other fields for fresh entry when picking subsequent sessions
                if (completedSessions > 0) {
                    this._testingdata['testing_description'] = '';
                    this._testingdata['testing_description_right'] = '';
                    this._testingdata['testing_attender_name2'] = null;
                    this._testingdata['empid2'] = null;
                    if (this.emplist2Ctrl) {
                        this.emplist2Ctrl.setValue(null);
                    }
                }

                this.therapyDoneCtrl.enable();
                if (this.nextFollowupDateCtrl) {
                    this.nextFollowupDateCtrl.enable();
                }
                if (this.assessmentDoneCtrl) this.assessmentDoneCtrl.disable();
            } else {
                this.therapyDoneCtrl.disable();
                if (this.nextFollowupDateCtrl) {
                    this.nextFollowupDateCtrl.disable();
                }
            }
        }
    }


    get testingdata(): any[] {
        return this._testingdata;
    }

    @Output() testingTrailLoadEvent = new EventEmitter();
    @ViewChild('emplistAutoComp') emplistAutoComp;
    @ViewChild('singleClientDetails') singleClientDetails;
    @ViewChild('testingtypeAutoComp') testingtypeAutoComp;
    filteredEmp: Observable<any[]>;
    filteredEmp2: Observable<any[]>;
    filteredTypes: Observable<any[]>;
    filteredComplaint: Observable<any[]>;
    minDate: any;
    testingList: any[] = [];
    testingDetailsList: any[] = [];
    octTypeList: any[] = [];
    octInitiatedByCtrl: FormControl;
    octInitiatedByList: any[] = [];
    filteredOctInitiatedBy: Observable<any[]>;
    octFromWalkin: boolean = false;
    isLoading: boolean = false;
    //testHeadClassName:string = 'modal-header';
    //typeList = ['Doctor', 'Others'];

    constructor(private testingTrailService: TestingTrailService, public snackBar: MdSnackBar, public bsModalRef: BsModalRef, public toasterService: ToasterService, private commonService: CommonService, private octTypeService: OctTypeService) {
        this.octInitiatedByCtrl = new FormControl('');
        this.filteredOctInitiatedBy = this.octInitiatedByCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterOctInitiatedBy(name) : this.octInitiatedByList.slice());
        //FOR AUTO COMPLETE VALIDATION --- BRAND MODEL
        function hasValidTesting(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No" && ledgerID != "OST" && ledgerID != "Trial Not Willing") {
                retVal = { inValidTesting: true };
            }

            return retVal;
        }
        this.testCtrl = new FormControl('', [
            Validators.required,
            hasValidTesting.bind(this)
        ]);
        this.testList = ['Yes', 'No', 'OST', 'Trial Not Willing'];

        //FOR AUTO COMPLETE VALIDATION --- OST DONE
        function hasValidOstDone(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No") {
                retVal = { inValidOstDone: true };
            }
            return retVal;
        }
        this.ostDoneCtrl = new FormControl('', [
            Validators.required,
            hasValidOstDone.bind(this)
        ]);
        this.ostDoneList = ['Yes', 'No'];

        //FOR AUTO COMPLETE VALIDATION --- ASSESSMENT DONE
        function hasValidAssessmentDone(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No") {
                retVal = { inValidAssessmentDone: true };
            }
            return retVal;
        }
        this.assessmentDoneCtrl = new FormControl('', [
            Validators.required,
            hasValidAssessmentDone.bind(this)
        ]);
        this.assessmentDoneList = ['Yes', 'No'];

        //FOR AUTO COMPLETE VALIDATION --- THERAPY DONE
        function hasValidTherapyDone(input: FormControl) {
            let val = input.value, retVal = null;
            if (this.therapyDoneList && this.therapyDoneList.indexOf(val) == -1) {
                retVal = { inValidTherapyDone: true };
            }
            return retVal;
        }
        this.therapyDoneCtrl = new FormControl('', [
            Validators.required,
            hasValidTherapyDone.bind(this)
        ]);

        this.nextFollowupDateCtrl = new FormControl('', [Validators.required]);

        //FOR AUTO COMPLETE VALIDATION --- BILATERAL WILLING CLIENT
        function hasValidBilateralWilling(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No") {
                retVal = { inValidBilateralWilling: true };
            }
            return retVal;
        }
        this.bilateralWillingCtrl = new FormControl('', [
            Validators.required,
            hasValidBilateralWilling.bind(this)
        ]);
        this.bilateralWillingList = ['Yes', 'No'];

        //FOR AUTO COMPLETE VALIDATION ---
        function hasValidBill(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No") {
                retVal = { inValidBill: true };
            }

            return retVal;
        }
        this.billGenCtrl = new FormControl('', [
            Validators.required,
            hasValidBill.bind(this)
        ]);

        this.billList = ['Yes', 'No'];
        //FOR AUTO COMPLETE VALIDATION --- 
        function hasValidRoute(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No") {
                retVal = { inValidRoute: true };
            }

            return retVal;
        }
        this.routeCtrl = new FormControl('', [
            Validators.required,
            hasValidRoute.bind(this)
        ]);

        this.routeOptList = ['Yes', 'No'];

        function hasEmp(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidEMP: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidEMP: true };
            }
            return retVal;
        }
        this.emplistCtrl = new FormControl('', [
            Validators.required,
            hasEmp.bind(this)
        ]);
        this.filteredEmp = this.emplistCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterHa(name) : this.haList.slice());

        // Attender Name 2 - optional field (no required validator)
        function hasEmp2(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidEMP: true };
            }
            return retVal;
        }
        this.emplist2Ctrl = new FormControl('', [
            hasEmp2.bind(this)
        ]);
        this.filteredEmp2 = this.emplist2Ctrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterHa(name) : this.haList.slice());

        function hasComplaint(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidComplaint: true };
            }
            /* if (ModelID && typeof ModelID === 'string') {
                 retVal = { inValidComplaint: true };
             }*/
            return retVal;
        }
        this.complaintCtrl = new FormControl('', [
            Validators.required,
            hasComplaint.bind(this)
        ]);
        //  this.halistCtrl = new FormControl();
        this.filteredComplaint = this.complaintCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterComplaint(name) : this.complaintList.slice());




        //FOR AUTO COMPLETE VALIDATION ---
        function hasValidTestingType(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidTestingtype: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidTestingtype: true };
            }
            return retVal;
        }
        this.testingtypeCtrl = new FormControl('', [
            Validators.required,
            hasValidTestingType.bind(this)
        ]);
        // this.testingtypeCtrl = new FormControl();
        // this.filteredTypes = this.testingtypeCtrl.valueChanges
        //     .startWith(null)
        //     .map(name => name ? this.filterTypes(name) : this.testingList.slice());


    }

    ngOnInit(): void {
        this.loadClientTypeList();
        this.loadComplaint();
        this.loadChallanHaList();
        this.loadOctTypeList();

        setTimeout(() => {
            $('#testing').focus();
            // Initialize form controls with existing data
            this.initializeFormControls();
        }, 1000);

        this.minDate = new Date(new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate());
    }

    initializeFormControls(): void {
        if (this.testingdata) {
            // Set Bill Generation
            if (this.billGenCtrl && this.testingdata['bill_gen']) {
                this.billGenCtrl.setValue(this.testingdata['bill_gen']);
            }

            // Set Testing Details (if it's an array)
            if (this.testingtypeCtrl && this.testingdata['testing_details_id']) {
                const testingIds = this.testingdata['testing_details_id'];
                if (typeof testingIds === 'string') {
                    // Convert comma-separated string to array
                    const idsArray = testingIds.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id));
                    this.testingtypeCtrl.setValue(idsArray);
                } else if (Array.isArray(testingIds)) {
                    this.testingtypeCtrl.setValue(testingIds);
                }
            }

            // Set Attender Names (testing_attender_name and empid2)
            if (this.emplistCtrl && this.testingdata['testing_attender_name']) {
                this.emplistCtrl.setValue(this.testingdata['testing_attender_name']);
            }
            if (this.emplist2Ctrl && this.testingdata['empid2']) {
                this.emplist2Ctrl.setValue(this.testingdata['empid2']);
            }

            console.log('Form initialized with data:', {
                bill_gen: this.testingdata['bill_gen'],
                testing_details_id: this.testingdata['testing_details_id'],
                testing_attender_name: this.testingdata['testing_attender_name'],
                empid2: this.testingdata['empid2'],
                testing_description_right: this.testingdata['testing_description_right']
            });
        }
    }

    initializeFormControlsAfterLoad(): void {
        if (this.testingdata) {
            // Set Bill Generation
            if (this.billGenCtrl && this.testingdata['bill_gen']) {
                this.billGenCtrl.setValue(this.testingdata['bill_gen']);
            }

            // Set Testing Details (if it's an array)
            if (this.testingtypeCtrl && this.testingdata['testing_details_id']) {
                const testingIds = this.testingdata['testing_details_id'];
                if (typeof testingIds === 'string') {
                    // Convert comma-separated string to array
                    const idsArray = testingIds.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id));
                    this.testingtypeCtrl.setValue(idsArray);
                } else if (Array.isArray(testingIds)) {
                    this.testingtypeCtrl.setValue(testingIds);
                } else {
                    // Single value - convert to array
                    this.testingtypeCtrl.setValue([testingIds]);
                }
            }

            console.log('Form controls initialized after load:', {
                bill_gen: this.testingdata['bill_gen'],
                testing_details_id: this.testingdata['testing_details_id']
            });
        }
    }
    loadClientDetails(clientID) {
        this.singleClientDetails.loadClient(clientID);//TO LOAD CLIENT OBJECT
        //TO SET SATISFIED NOT SATISFIED COMBO
    }
    onEnterKeyPressed(nextEl: string): void {
        if (_.isEmpty(document.getElementById(nextEl))) {
            nextEl = 'testingtype_obj';
        }
        $('#' + nextEl).focus();
    }
    // displayType(type_id: number) {
    //     if (type_id && this.testingdata.length > 0) {
    //         let ftype = _.find(this.testingdata, { 'id': type_id });
    //         return ftype['name'];
    //     } else {
    //         return '';
    //     }
    // }

    // filterTypes(name: string) {
    //     name = _.escapeRegExp(name);
    //     return this.testingdata.filter(type => (new RegExp(name, 'gi').test(type.name) || new RegExp(name, 'gi').test(type.fees)));
    // }

    loadClientTypeList() {
        let that = this;
        this.commonService
            .getTestingtypeList()
            .then(function (res: any) {
                that.testingList = res;
                // that.testingtypeCtrl.setValue(that.testingdata['testing_id']);
                // Extract testing_id from received data
                console.log("that.testingdata['testing_id']", that.testingdata['testing_id']);
                // Convert testing_id to a string to ensure compatibility
                let testingIdString = that.testingdata['testing_id'].toString();
                let testingIds;
                if (testingIdString.includes(',')) {
                    testingIds = testingIdString.split(',');
                } else {
                    testingIds = [testingIdString];
                }
                console.log("testingIds", testingIds);
                // Find matching names
                const matchingNames = testingIds.map(id => {
                    const matchingObject = that.testingList.find(obj => obj.id === parseInt(id));
                    return matchingObject ? matchingObject : null;
                }).filter(name => name !== null);

                // Set value of testingtypeCtrl to matched names
                that.testingDetailsList = matchingNames;
            });
    }

    loadComplaint() {
        let that = this;
        this.commonService
            .getComplaintList()
            .then(function (res: any) {
                that.complaintList = res;
                that.complaintCtrl.setValue(that.testingdata['complaint'] || that.testingdata['comp_name']);

            });
    }
    filterComplaint(comp_name: string) {
        comp_name = _.escapeRegExp(comp_name);
        return this.complaintList.filter(item => (new RegExp(comp_name, 'gi').test(item.comp_name)
            || new RegExp(comp_name, 'gi').test(item.comp_name)));
    }

    displayComplaint(comp_name: string) {

        if (comp_name && this.complaintList.length > 0) {
            let flist = _.find(this.complaintList, { 'comp_name': comp_name });
            //this.challangriddata['avail_qty'] = fhalist.avail_qty;
            //  this.getModelSerialNo(it_id);

            return flist['comp_name'];
        }
        return '';
    }


    loadChallanHaList() {
        let that = this,
            data = {
                name: '',
                type: 'challan'
            };
        this.commonService
            .getEmployeeName(data)
            .then(function (res: any) {
                that.haList = res['data'];
                that.octInitiatedByList = res['data'];
                that.emplistCtrl.setValue(that.testingdata['testing_attender_name']);
                that.emplist2Ctrl.setValue(that.testingdata['empid2']);
                that.octInitiatedByCtrl.setValue(that.testingdata['oct_initiated_by'] || '');
                if (that.octFromWalkin) {
                    that.octInitiatedByCtrl.disable();
                }
                that.initializeFormControlsAfterLoad();
            });
    }

    filterHa(empname: string) {
        empname = _.escapeRegExp(empname);
        return this.haList.filter(ha => (new RegExp(empname, 'gi').test(ha.empid)
            || new RegExp(empname, 'gi').test(ha.empname)));
    }

    displayHa(item_id: number) {

        if (item_id && this.haList.length > 0) {
            let fhalist = _.find(this.haList, { 'empid': item_id });
            //this.challangriddata['avail_qty'] = fhalist.avail_qty;
            //  this.getModelSerialNo(item_id);
            return fhalist['empname'];
        }
        return '';
    }
    loadOctTypeList() {
        let that = this;
        this.octTypeService.getOctTypeList({ start: 0, limit: 1000, orderColumn: 'name', orderDir: 'asc' })
            .then(function (res: any) {
                that.octTypeList = (res.data || []).filter((o: any) => o.status === 'Active');
                if (that._testingdata && that._testingdata['oct_type_id']) {
                    let val = that._testingdata['oct_type_id'];
                    that._testingdata['oct_type_id'] = null;
                    setTimeout(() => { that._testingdata['oct_type_id'] = val; }, 0);
                }
            });
    }

    filterOctInitiatedBy(name: string) {
        name = _.escapeRegExp(name);
        return this.octInitiatedByList.filter(emp => (new RegExp(name, 'gi').test(emp.empid)
            || new RegExp(name, 'gi').test(emp.empname)));
    }

    displayOctTypeFn(octId: any): string {
        if (octId && this.octTypeList && this.octTypeList.length > 0) {
            let fitem = _.find(this.octTypeList, { 'id': Number(octId) });
            if (fitem) return fitem['name'];
        }
        return '';
    }

    displayOctInitiatedByFn(empID: any): string {
        if (empID && this.octInitiatedByList.length > 0) {
            let fitem = _.find(this.octInitiatedByList, { 'empid': empID });
            if (fitem) {
                this._testingdata['oct_initiated_by'] = empID;
                return fitem['empname'];
            }
        }
        return '';
    }

    onTestingChange(value: string): void {
        if (value === 'No') {
            this.complaintCtrl.disable();
            this.emplistCtrl.disable();
            this.emplist2Ctrl.disable();
            this.testingtypeCtrl.disable();
            this.billGenCtrl.disable();
            this.ostDoneCtrl.disable();
            this.bilateralWillingCtrl.disable();
        } else {
            this.complaintCtrl.enable();
            this.emplistCtrl.enable();
            this.emplist2Ctrl.enable();
            this.testingtypeCtrl.enable();
            this.billGenCtrl.enable();
            this.ostDoneCtrl.enable();
            this.bilateralWillingCtrl.enable();
        }
    }

    onSaveTestingTrial(): void {
        let toast = {
            type: 'warning',
            title: 'WARNING'
        };
        // if (_.isEmpty(_.toString(this.testingdata['id']))) {
        //     toast['body'] = 'Please Select Testing ';
        //     this.toasterService.pop(toast);
        //     return;
        // }
        if (this.testingdata['testing'] !== 'No' && _.isEmpty(this.testingdata['bill_gen'])) {
            toast['body'] = 'Please Select Bill Generation';
            this.toasterService.pop(toast);
            return;
        }
        // Route to Trail validation - Commented out as field is now auto-set in backend
        // OST = Yes, Others = No
        /*
        // Only validate Route to Trail when OST is selected
        if (this.testingdata['testing'] == 'OST') {
            if (_.isEmpty(this.testingdata['route_trail']) && _.isEmpty(this.testingdata['route_testing'])) {
                toast['body'] = 'Please Select Route to Trail ';
                this.toasterService.pop(toast);
                return;
            }
        }
        */
        if (this.testingdata['status'] == 'Re-Program' || this.testingdata['status'] == 'Re-Check up') {
            if (_.isEmpty(this.testingdata['testing_feedback'])) {
                toast['body'] = 'Please Select Satisfied (or) Not-Satisfied';
                this.toasterService.pop(toast);
                return;
            }
            if (!_.isDate(this.testingdata['nxt_fol_date'])) {
                toast['body'] = 'Please Select Next Follow Up Date';
                this.toasterService.pop(toast);
                return;
            } else {
                this.testingdata['nxt_fol_conv_date'] = moment(this.testingdata['nxt_fol_date']).format('YYYY-MM-DD');
            }
        }

        // Sync FormControl value back to model before saving
        if (this.testingdata['status'] == 'Therapy' && this.nextFollowupDateCtrl.value) {
            // Get the Date object from the FormControl
            const dateValue = this.nextFollowupDateCtrl.value;
            // Store as Date object first for potential reuse
            this.testingdata['nxt_fol_conv_date'] = dateValue;
            // Format to YYYY-MM-DD string for API
            this.testingdata['nxt_fol_conv_date'] = moment(dateValue).format('YYYY-MM-DD');
        }

        let that = this;
        // data = {
        //     mode: this.testingdata['mode']
        // };
        this.testingdata['is_edit'] = this.testingdata['is_edit'] || 'No';
        this.isLoading = true;
        this.testingTrailService
            .updateTestingTrial(this.testingdata)
            .then(function (res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal(
                        'SUCCESS',
                        res.message,
                        'success'
                    );
                    that.bsModalRef.hide();
                    that.testingTrailLoadEvent.emit();
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };

                    that.toasterService.pop(toast);
                }

            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/testingTrail/addTesting.component.ts